import { Trans } from "@lingui/react";
import { memo, type ReactNode, type RefObject } from "react";
import { useOtherLocations } from "src/context/DealerDataProviderContext.tsx";
import { TabId } from "../../utils/tabs.ts";
import LocationCard from "../Components/Cards/LocationCard.tsx";
import { ScrollContainer } from "../Components/ScrollContainer.tsx";
import "./sections.css";
import { DealerAds } from "./DealerAds.tsx";

export const OtherLocations = memo(({ ref }: { ref: RefObject<HTMLDivElement | null> }) => {
  const { otherLocations, latestGroupAds } = useOtherLocations();

  if (!otherLocations || otherLocations.length === 0) {
    return null;
  }

  return (
    <Container>
      <section id={TabId.OtherLocations} ref={ref} className="section w-full my-56">
        <header className="flex gap-16 items-center mb-16">
          <h2 className="t3 mb-0">
            <Trans id="dealerBrandingLayout.departments.otherDepartments" message="Other departments" />
            {` (${otherLocations.length})`}
          </h2>
        </header>
        <ScrollContainer className="flex gap-x-16 overflow-x-scroll overflow-y-hidden" scrollButtonOffset={60}>
          {otherLocations.map((location) => (
            <LocationCard key={location.organisationId} {...location} />
          ))}
        </ScrollContainer>
      </section>
      {latestGroupAds && latestGroupAds.length > 0 && <DealerAds ads={latestGroupAds} className="mb-40" />}
    </Container>
  );
});

const Container = ({ children }: { children: ReactNode }) => {
  return (
    // -mt-1 is used to make the container cover the bottom border of the previous section
    // mx-[-16px] and xl:mx-[-31px] are used to ensure the background color extends to the edges of the viewport when banner ads with too low z-index are rendered
    <div className="relative mt-16 mx-[-16px] xl:mx-[-31px] px-16 xl:px-[31px] s-bg-info-subtle">
      <div
        className="absolute s-bg-info-subtle h-full"
        style={{ width: "99vw", left: "50%", transform: "translate(-50%)", zIndex: -1 }}
      />
      {children}
    </div>
  );
};
